import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/Home.vue'
import Equipment from '../views/Equipment.vue'
import Wheelchairs from '../views/Wheelchairs.vue'
import Products from '../views/Products.vue'
import About from '../views/About.vue'
import ProductDetail from '../views/ProductDetail.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/equipment',
    name: 'Equipment',
    component: Equipment
  },
  {
    path: '/wheelchairs',
    name: 'Wheelchairs',
    component: Wheelchairs
  },
  {
    path: '/products',
    name: 'Products',
    component: Products
  },
  {
    path: '/about',
    name: 'About',
    component: About
  },
  {
    path: '/product/:id',
    name: 'ProductDetail',
    component: ProductDetail
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router 